module.exports = __webpack_public_path__ + "static/media/hide-list-red.2fda8ae8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/hide-list-red.svg
// module id = 1564
// module chunks = 0